export default __webpack_public_path__ + "static/media/success-v2.ca05b8fd.png";